import React, { useState, useEffect } from 'react';
import './style/VerifyCode.css';
import { useNavigate,useLocation } from 'react-router-dom';

const RegistrationPage = ({ setPhoneForVerify, setCarNumberForVerify, setShowVerify }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const state = location.state || {};
    const phoneFromNav = state.phone || '';
    const flag = state.flag || '';

    const [isOpen, setIsOpen] = useState(false);
    const [formData, setFormData] = useState({
        gosNumber: '',
        techPassport: '',
        phone: '',
    });

    useEffect(() => {
        if (phoneFromNav) {
            setFormData(prev => ({ ...prev, phone: phoneFromNav }));
        }
    }, [phoneFromNav]);

    const handleSubmit = async () => {
        const { gosNumber, techPassport, phone } = formData;

        if (!gosNumber || !techPassport || !phone) {
            alert('Пожалуйста, заполните все поля!');
            return;
        }

        try {
            const resp = await fetch('http://localhost:8081/api/users/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.1.0'
                },
                body: JSON.stringify({
                    phone,
                    carNumber: gosNumber,
                    carTechPassport: techPassport
                })
            });

            if (!resp.ok) {
                throw new Error('Ошибка регистрации');
            }

            setPhoneForVerify?.(phone); // Если переданы как props
            setCarNumberForVerify?.(gosNumber);
            setShowVerify?.(true);
            // ✅ Перенаправляем на страницу ввода кода
            navigate('/verify-code', {
                state: {
                    phone,
                    carNumber: gosNumber,
                    flag: 'profile'
                }
            });
            setIsOpen(false); // закрываем модалку
        } catch (err) {
            alert(err.message);
        }
    };

    return (
        <>


                <div className="modal-overlay">
                    <div className="modal-content">
                        <button className="close-button" onClick={() => setIsOpen(false)}>✖</button>
                        <section className="application-form">
                            <h2>📋 Форма регистрации</h2>
                            <input
                                id="gosNumber"
                                type="text"
                                placeholder="🚘 Гос. номер авто"
                                value={formData.gosNumber}
                                onChange={e => setFormData({ ...formData, gosNumber: e.target.value })}
                            />
                            <input
                                id="techPassport"
                                type="text"
                                placeholder="📄 Номер техпаспорта"
                                value={formData.techPassport}
                                onChange={e => setFormData({ ...formData, techPassport: e.target.value })}
                            />
                            <input
                                id="phone"
                                type="text"
                                placeholder="📱 Номер телефона"
                                value={formData.phone}
                                onChange={e => setFormData({ ...formData, phone: e.target.value })}
                            />
                            <button onClick={handleSubmit}>Подтвердить</button>
                        </section>
                    </div>
                </div>

        </>
    );
};

export default RegistrationPage;
